<template>
  <price-pre-port-list />
</template>

<script>
import PricePrePortList from '@/components/Cargo/Price/pricePrePortList'

export default {
  name: 'PricePrePort',
  components: {
    PricePrePortList
  }
}
</script>

<style scoped lang="scss">

</style>
